<template>
    <div>
        <div class="mt-5 text-center">
            send message
        </div>
    </div>
</template>
<script>
import CacheHelper from '@/helper/CacheHelper';
import sendtext from '../service/sendtext.js'
import ConfigManager from '@/config/ConfigManager';


export default {
    name: 'sendtext',
    data: function() {
        return {
            cache: new CacheHelper()
        };
    },
    created: function() {
        this.sendMessage();
    },
    methods: {
        sendMessage: async function() {
            let params = {
                text: this.$route.query.text,
                lineUserId: this.cache.getCache('line_user_id')
            }
            await this.apiSendText(params)
            
            const lineId = ConfigManager.getLineId()
            let urlSchemeOpenLine = "https://line.me/R/ti/p/" + lineId

            window.location = urlSchemeOpenLine

        },
        apiSendText: function(params) {
            return new Promise((resolve) => {
                sendtext.apiSendMessage(params).subscribe({
                    next: (res) => {
                        resolve(res)
                    },
                    error: (error) => {
                        console.log(error)
                        resolve(null)
                    }
                })
            })
        },
    }
}
</script>
